import withRole from './role';
import withRequirements from './requirements';
import withScreenSize from './screenSize';

export { withRole, withRequirements, withScreenSize };



// WEBPACK FOOTER //
// ./src/components/hoc/index.js